import React, { useEffect, useState } from 'react';
import Navbar from './navbar';
import About from './about';
import Services from './services';
import Footer from './footer';
import Targets from './targets';
import Experts from './experts';
import Testimonials from './testimonials';
import Partners from './partners';
import Banner from './banner';
import Contact from './contact';

const Home = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const scrollToSection = () => {
      const hash = window.location.hash;

      if (hash) {
        const targetSection = document.querySelector(hash);

        if (targetSection) {
          targetSection.scrollIntoView({ behavior: 'smooth' });
        }
      }
    };

    scrollToSection();

    window.addEventListener('load', scrollToSection);

    return () => {
      window.removeEventListener('load', scrollToSection);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <div className="home-container">
      <div id="Home">
        <Navbar />

        <div id="consultingCarousel">
          <Banner />
        </div>

        <div id="About">
          <About />
        </div>

        <div id="Services">
          <Services />
        </div>

        <div id="Targets">
          <Targets />
        </div>

        <div id="Experts">
          <Experts />
        </div>

        <div id="Testimonials">
          <Testimonials />
        </div>

        <div id="Partners">
          <Partners />
        </div>
        <div id="Contact">          
        <Contact/>
        </div>
        <div id="Footer">          
          <Footer />
          </div>
        {/* Scroll to Top Button */}
        {isVisible && (
          <div className="scroll-to-top">
            <button onClick={scrollToTop} className="button-nav">
              <i className="fa fa-arrow-up" style={{ fontSize: '24px', color: '#0070C0' }} aria-hidden="true"></i>
            </button>
          </div>
        )}
      </div>

      {/* Styles */}
      <style jsx>{`
        .scroll-to-top {
          position: fixed;
          bottom: 20px;
          right: 20px;
          z-index: 1000;
          display: flex;
          justify-content: center;
          align-items: center;
        }

        .button-nav {
          background-color: white;
          border: 2px solid #48c7ec;
          border-radius: 10%;
          padding: 10px;
          cursor: pointer;
          box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
        }

        .button-nav:hover {
          background-color: #48c7ec;
          color: white;
        }
      `}</style>
    </div>
  );
};

export default Home;
